var _rect, _rect2, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEffortlessBackground(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 400,
    height: 400,
    viewBox: "0 0 400 400",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.00012207,
    width: 400,
    height: 400,
    rx: 32,
    fill: "#FCD4FF"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_53950_4755",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 400,
    height: 401
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    y: 0.00012207,
    width: 400,
    height: 400,
    rx: 32,
    fill: "#FFD2C3"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_53950_4755)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 354,
    cy: 400,
    r: 266,
    fill: "#FBC1FF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEffortlessBackground);
export default __webpack_public_path__ + "static/media/effortless-background.18bb63f5670cd86f13bda6c8b42035f5.svg";
export { ForwardRef as ReactComponent };